import { Component, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { DownloadModalService } from '../../services/download-modal.service';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../../services/api.service';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { CartService } from '../../services/cart.service';

const BASE_URL = environment.apiUrl;

@Component({
  selector: 'app-download-modal',
  templateUrl: './download-modal.component.html',
  styleUrls: ['./download-modal.component.css']
})
export class DownloadModalComponent implements OnInit, OnDestroy {
  isOpen = false;
  itemInfo: any = null;
  isFromCart: boolean = false;
  private sub?: Subscription;
  private infoSub?: Subscription;
  private fromCart?: Subscription;
  isLoading: boolean = false;


  encryptedData: string = "";
  accessCode: string = environment.ccAvenueAccessKey;
  formAction: string = environment.ccAvenuePayUrl;
  @ViewChild('form') form: ElementRef | undefined;

  constructor(private modalService: DownloadModalService, private http: HttpClient, private apiService: ApiService, private router: Router, private cartService: CartService) {}

  ngOnInit(): void {
    this.sub = this.modalService.isOpen$.subscribe(state => {
      this.isOpen = state;
    });
    this.infoSub = this.modalService.info$.subscribe(info => {
      this.itemInfo = info;
    });
    this.fromCart = this.modalService.fromCart$.subscribe(fromCartBool => {
      this.isFromCart = fromCartBool;
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this.infoSub?.unsubscribe();
    this.fromCart?.unsubscribe();
  }

  close(): void {
    this.modalService.close();
  }

  onSubmit(event: Event): void {
    event.preventDefault();
    const form = event.target as HTMLFormElement;
    const formData = new FormData(form);
    this.isLoading = true;

    if (this.itemInfo) {
      if (this.itemInfo.package_id) {
        formData.append('package_id', this.itemInfo.package_id);
      } else if (this.itemInfo.template_id) {
        formData.append('template_id', this.itemInfo.template_id);
      }
    } else {
      let cartData: any = [];
      this.cartService.items$.subscribe(items => {
        for (const element of items) {
          cartData.push({
            'type': 'template',
            'id': element.id
          });
        }
      });
      formData.append('cartData', JSON.stringify(cartData));
    }

    formData.append('downloadRel', this.isFromCart ? 'cart' : 'single');

    const url = `${BASE_URL}/api/packages/download`;
    this.http.post(url, formData).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.encryptedData = res.encrypted_data;
          setTimeout(() => {
            this.close();
            if(this.form) {
              this.form.nativeElement.submit();
            }
          }, 500);
          // this.router.navigate(['/thank-you']);
        } else {
          alert('Error: ' + res.message);
        }
      },
    });
  }
}

